<template>
  <div :dir="isHebrew ? 'rtl' : 'ltr'">
    <div v-if="shouldShowFloatingButton" ref="floatingRoot" :style="floatingStyle">
      <a
        class="trip-btn-bg btn-primary"
        @click="goToSearchAccommodationsFromAccommodationPage"
        style="white-space: nowrap; padding: 9px 20px; font-size: 16px; display: block;">
        {{ t('accommodationChooseFromMyHotels') }}
      </a>
    </div>
   <SingleRideHeader
      :presentedText="t('accommodationEditPresentedText')"
   />
      <div class="trip-card-section">
        <div class="container">
          <div class="trip-card-top trip-card-top2">
            <a
              v-if="this.allRide?.ride?.id"
              class="trip-btn-bg btn-greey"
              @click="ReturnToSingleRide()">
              {{ t('attractionEditingBackToTrip') }}
            </a>
            <a
              v-else
              class="trip-btn-bg btn-greey"
              @click="gooToRideManagerAttraction()">
              {{ t('attractionEditingBackToAttractionsEdit') }}
            </a>
            <h4>{{ t('accommodationDetailsTitle') }}</h4>
          </div>
        </div>
      </div>
      <!-- End card section -->

      <div 
        v-if="accommodationFormFromBaseRide && accommodationFormFromBaseRide.check_in_date"
        class="accommodation-reco-box"
        style="border: 1px solid #ccc; border-radius: 12px; padding: 20px; max-width: 500px; margin: 20px auto; font-family: sans-serif; background-color: #f9f9f9;">
        <p class="accommodation-reco-intro">{{ t('accommodationRecommendationIntro') }}</p>
     
        <ul style="list-style: none; padding: 0; line-height: 1.6; font-size: 1.5rem;">
          <li><strong>{{ t('accommodationRecommendationPlaceLabel') }}</strong> {{accommodationFormFromBaseRide.cuntry_and_city}}</li>
          <li><strong>{{ t('accommodationRecommendationDatesLabel') }}</strong> {{accommodationFormFromBaseRide.check_in_date}}{{ t('accommodationDateRangeSeparator') }}{{accommodationFormFromBaseRide.check_out_date}} </li>
        </ul>
        <h4 style="margin-top: 0; font-size: 1.5rem;">{{ t('accommodationRecommendationDatesNote') }}</h4>
      </div>

      <div class="trip-contact-form-section" style="position: relative;">
        <div class="container">
          <div class="trip-contact-wrap">
            <h4>{{ t('accommodationDetailsTitle') }}</h4>
            <div class="row">
              <div class="col-12 col-md-10 col-lg-6 mx-auto">
                <div class="accommodation-ad-slot mb-3">
                  <!-- Ad slot: same width as form, above video tutorial -->
                </div>
                <div class="video-tutorials-section accommodation-tutorial mb-3">
                  <div class="video-tutorials-title">
                    <span class="icon">🎥</span> {{ t('accommodationTutorialsRecommendedTitle') }}
                  </div>
                  <div class="video-tutorials-list">
                    <div class="video-tutorial-item">
                      <div
                        class="video-tutorial-card"
                        @click="toggleAccommodationVideo"
                      >
                        <div class="video-tutorial-header">
                          <div class="video-tutorial-title">{{ t('accommodationTutorialVideoTitle') }}</div>
                          <span class="video-tutorial-arrow" :class="{ 'is-open': showAccommodationVideo }">▶</span>
                        </div>
                      </div>
                      <transition name="slide-down">
                        <div v-if="showAccommodationVideo" class="video-container-wrapper">
                          <div class="tutorial-video-container">
                            <video
                              v-if="accommodationTutorialVideo.videoUrl && !accommodationTutorialVideo.error"
                              ref="accommodationVideo"
                              :src="accommodationTutorialVideo.videoUrl"
                              controls
                              class="tutorial-video"
                              @loadstart="onAccommodationVideoLoadStart"
                              @error="onAccommodationVideoError"
                              @loadeddata="onAccommodationVideoLoaded"
                              preload="none"
                            >
                              {{ t('videoTagNotSupported') }}
                            </video>
                            <div v-else-if="accommodationTutorialVideo.loading" class="video-loading">
                              <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">{{ t('loading') }}</span>
                              </div>
                              <p>{{ t('attractionEditingLoadingVideo') }}</p>
                            </div>
                            <div v-else-if="accommodationTutorialVideo.error" class="video-error">
                              <p>{{ t('attractionEditingVideoLoadError') }}</p>
                              <button type="button" class="retry-button" @click="retryAccommodationVideo">{{ t('attractionEditingRetryVideo') }}</button>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
                <div class="trip-contact-column">
                  <!-- Stage 1: Only show autocomplete -->
                  <div v-if="!isPlaceSelected" class="trip-contact-field">
                    <div class="autocomplete-intro">
                      {{ t('attractionEditingAutocompleteIntro') }}
                    </div>
                    <label>
                      {{ t('accommodationHotelNameLabel') }}<span>*</span>
                      <small @mouseover="showInfoTooltip = true" @mouseleave="showInfoTooltip = false" style="cursor: help; float: left;">
                        {{ t('attractionEditingWhenToChangeField') }} ℹ️
                      </small>
                    </label>
                    
                    <!-- Info tooltip -->
                    <div v-if="showInfoTooltip" class="info-tooltip">
                      <span v-html="t('accommodationLocationFieldTooltip')"></span>
                    </div>

                    <div class="trip-contact-input">
                      <gmap-autocomplete
                        id="accommodation-name-input"
                        @place_changed="handlePlaceChanged"
                        :select-first-on-enter="true"
                        :placeholder="t('attractionEditingAutocompletePlaceholder')"
                        size=""
                        class="accommodation-input"
                        :options="{ sessionToken: sessionToken }"
                      >
                      </gmap-autocomplete>
                    </div>

                    <!-- Explanation box -->
                    <div class="explanation-box">
                      
                      <div class="explanation-section important-note">
                        <div class="explanation-title">
                          <span class="icon">⚡</span> {{ t('attractionEditingImportantToKnow') }}:
                        </div>
                        <div class="explanation-content">
                          {{ t('accommodationChooseSpecificPlace') }}
                          <br><br>
                          {{ t('accommodationExamplesTitle') }}
                          <ul style="margin: 8px 0 8px 0; padding-right: 20px;">
                            <li>{{ t('accommodationExampleSpecificHotel') }}</li>
                            <li>{{ t('accommodationExampleAreaVillage') }}</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                  </div>

                  <!-- Stage 2: Show all other fields after place is selected -->
                  <template v-if="isPlaceSelected">
                     <div
                       v-if="showMasterFieldReference"
                       class="master-ref-banner"
                     >
                       {{ t('accommodationMasterRefBanner') }}
                     </div>
                     <!-- Show place name and change button when NOT in edit mode -->
                     <div class="trip-contact-field" style="position: relative;">
                       <div style="margin-bottom: 10px;">
                         <div style="display: flex; align-items: center; justify-content: flex-end; direction: rtl; padding: 12px; background-color: #f8f9fa; border-radius: 8px; border: 1px solid #e9ecef; gap: 12px;">
                           <div v-if="!haveFormFromRide&&currentPlace?.name" style="flex: 1; text-align: right;">
                            <span style="color: #0D2F29; font-size: 14px; font-weight: 500; margin-left: 8px;">
                               {{ t('attractionEditingSelectedPlaceLabel') }}
                             </span>
                             <span style="color: #0D2F29; font-size: 16px; font-weight: 600;">
                               {{ currentPlace?.name }}
                             </span>
                           </div>
                           <button
                             type="button"
                             @click="returnToPlaceSelection"
                             style="cursor: pointer; background-color: #07A0C3; color: white; border: none; border-radius: 6px; padding: 8px 16px; font-size: 14px; font-weight: 500; transition: background-color 0.2s; flex-shrink: 0;"
                             @mouseover="$event.target.style.backgroundColor = '#0590b0'"
                             @mouseleave="$event.target.style.backgroundColor = '#07A0C3'"
                           >
                             {{ t('attractionEditingChangePlaceButton') }}
                           </button>
                           <small 
                             @mouseover="showChangePlaceExplanation = true" 
                             @mouseleave="showChangePlaceExplanation = false"
                             style="cursor: help; color: #07A0C3; font-size: 16px; flex-shrink: 0;"
                           >
                             ℹ️
                           </small>

                         </div>
                       </div>
                       <!-- Explanation tooltip -->
                       <div v-if="showChangePlaceExplanation" class="info-tooltip change-place-explanation" v-html="t('attractionEditingChangePlaceTooltip')"></div>
                     </div>

                     
                     <div class="trip-contact-field">
                       <label>{{ t('accommodationHotelNameLabel') }}<span>*</span></label>
                       <div
                         v-if="showMasterFieldReference"
                         class="master-ref-strip"
                       >
                         <span class="master-ref-template">{{ t('accommodationMasterRefTemplate') }}:</span>
                         <span class="master-ref-value">{{ formatMasterValue('name') }}</span>
                         <button
                           type="button"
                           class="master-ref-btn"
                           @click="applyMasterField('name')"
                         >
                           {{ t('accommodationMasterRefUseBase') }}
                         </button>
                       </div>
                       <div class="trip-contact-input">
                         <input
                           v-model="internalAccommodationName"
                           :placeholder="t('accommodationHotelNameLabel')"
                           type="text"
                           required
                         >
                       </div>
                     </div>
                  
                  <div v-if="!isManagerAccommodationEdit" :dir="isHebrew ? 'rtl' : 'ltr'" class="trip-contact-field">
                    <label for="date-picker" class="mb-2" >
                      <template v-if="isHebrew">
                        <span>*</span>
                        {{ t('accommodationCheckInOutLabel') }}
                      </template>
                      <template v-else>
                        {{ t('accommodationCheckInOutLabel') }}
                        <span>*</span>
                      </template>
                    </label>
                    <div
                      v-if="showMasterFieldReference"
                      class="master-ref-strip"
                    >
                      <span class="master-ref-template">{{ t('accommodationMasterRefTemplate') }}:</span>
                      <span class="master-ref-value">{{ formatMasterValue('dates') }}</span>
                      <button
                        type="button"
                        class="master-ref-btn"
                        @click="applyMasterField('dates')"
                      >
                        {{ t('accommodationMasterRefUseBase') }}
                      </button>
                    </div>
                    <div class="trip-contact-input d-flex accommodation-date-row">
                      <img
                        class="coulunder_image mr-3"
                        :src="require('@/assets/images/icons/icons8-edit-calendar-50.png')"
                        :alt="t('calendarIconAlt')"
                        style="width: 24px; height: 24px; cursor: pointer;"
                        @click="openCalendar"
                      >
                      <flat-pickr
                        v-model="date"
                        id="date-picker"
                        ref="datePicker"
                        class="border border-primary rounded-pill px-3 py-2 w-100 form-control datepicker text-right"
                        :placeholder="t('accommodationCheckInOutPlaceholder')"
                        :config="datePickerConfig"
                      ></flat-pickr>
                    </div>
                  </div>

                  <div v-if="isUserManager && !isManagerAccommodationEdit" class="trip-contact-field accommodation-voucher-section">
                    <div
                      v-for="(url, idx) in accommodationVoucherUrls"
                      :key="idx"
                      class="voucher-row"
                    >
                      <span class="material-icons voucher-row-icon">{{ isVoucherImage(url) ? 'image' : 'picture_as_pdf' }}</span>
                      <span class="voucher-row-name">{{ getVoucherFilename(url) }}</span>
                      <button type="button" class="voucher-row-remove" @click="removeAccommodationVoucher(idx)">✕</button>
                    </div>
                    <VoucherUpload
                      v-if="accommodationVoucherUrls.length < 10"
                      ref="accommodationVoucherUpload"
                      :value="null"
                      :reset-after-upload="true"
                      :entity-id="accommodationFormFromRide?.id"
                      :fallback-id="allRide?.ride?.id"
                      entity-type-prefix="accommodation_id"
                      storage-folder="videos_and_audios"
                      instance-id="accommodation-new"
                      @uploaded="handleAccommodationVoucherUploaded"
                      @upload-progress="handleAccommodationVoucherUploadProgress"
                    />
                    <p v-else class="voucher-max-reached-msg">{{ t('voucherMaxReached') }}</p>
                  </div>

                  <div class="trip-contact-field">
                    <div class="map-explanation">
                      <h5 class="map-explanation-title">
                        {{ t('attractionEditingWantToChangeLocation') }} 
                        <span 
                          class="info-icon" 
                          @click="showMapInfoTooltip = !showMapInfoTooltip"
                          @mouseenter="showMapInfoTooltip = true"
                          @mouseleave="showMapInfoTooltip = false"
                        >
                          ℹ️
                        </span>
                      </h5>
                      <div v-if="showMapInfoTooltip" class="map-info-tooltip">
                        <span v-html="t('attractionEditingMapTooltip')"></span>
                      </div>
                    </div>
                    <GlobalMap
                      class="single_ride_map11"
                      passed_class="single_ride_map"
                      @serchPointChange="handleUpdateserchpoint" >
                    </GlobalMap>
                    <div
                      v-if="showMasterFieldReference"
                      class="master-ref-strip master-ref-strip-map"
                    >
                      <span class="master-ref-template">{{ t('accommodationMasterRefTemplate') }}:</span>
                      <span class="master-ref-value">{{ formatMasterValue('location') }}</span>
                      <button
                        type="button"
                        class="master-ref-btn"
                        @click="applyMasterField('location')"
                      >
                        {{ t('accommodationMasterRefUseBase') }}
                      </button>
                    </div>
                  </div>

                  <button id="submit-btn1" v-b-toggle.collapse-1 >{{ isAdvancedOptionsOpen ? t('attractionEditingHideAdvancedOptions') : t('attractionEditingShowAdvancedOptions') }}</button>
                  <b-collapse id="collapse-1" class="mt-2" v-model="isAdvancedOptionsOpen">
                    <div class="trip-contact-field">
                      <InsertLinkToTextbox
                        :value="accommodationOpenText"
                        :setValue="val => accommodationOpenText = val"
                        textareaRef="accommodation_text_editor"
                      />
                      <label>{{ t('accommodationFreeTextLabel') }}</label>
                      <div
                        v-if="showMasterFieldReference"
                        class="master-ref-strip"
                      >
                        <span class="master-ref-template">{{ t('accommodationMasterRefTemplate') }}:</span>
                        <span class="master-ref-value">{{ formatMasterValue('text') }}</span>
                        <button
                          type="button"
                          class="master-ref-btn"
                          @click="applyMasterField('text')"
                        >
                          {{ t('accommodationMasterRefUseBase') }}
                        </button>
                      </div>
                      <div class="trip-contact-input">
                        <textarea
                          ref="accommodation_text_editor"
                          name="textarea"
                          :placeholder="t('accommodationFreeTextLabel')"
                          v-model="accommodationOpenText"
                          class="add_ride_boxes"
                          >
                        </textarea>
                      </div>
                    </div>
                    <div class="trip-contact-field">
                      <label>{{ t('attractionEditingImageLabel') }}</label>
                      <h3 v-if="this.isUplowding()" >{{Math.round(this.uploadValue)}}%</h3>
                      <div class="trip-contact-input file-uploade">
                        <span class="btn_upload">
                          <input  type="file"
                          name="file"
                          accept="image/*"
                          class="input-img"
                          v-on:change="uploadAccommodationImage"
                          id="accommodation-file">
                          {{ t('attractionEditingUploadImage') }}
                        </span>

                        <!-- 16:9 preview box - same visual behavior as SingleRide -->
                        <div v-if="isAccommodationImage" class="image-preview-wrapper">
                          <div class="attraction-image-top image-preview-16-9">
                            <div
                              class="attraction-image-top-bg"
                              :style="{ backgroundImage: `url('${accommodationImage}')` }"
                            ></div>
                            <img
                              :src="accommodationImage"
                              class="attraction-image-top-img"
                              :alt="accommodationName"
                            >
                          </div>
                          <button
                            @click="removeImage"
                            type="button"
                            id="removeImage1"
                            value="x"
                            class="rmv">
                            x
                          </button>
                        </div>
                        <div class="trip-input-icon trip-input-icon2">
                          <img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fediting_attraction_page%2Flink.png?alt=media&token=e70f1168-04b4-44fe-92f6-aa75bb313fc4" alt="">
                        </div>
                      </div>
                    </div>

                    <div class="trip-contact-field">
                      <label>{{ t('accommodationAreaNameLabel') }}</label>
                      <div
                        v-if="showMasterFieldReference"
                        class="master-ref-strip"
                      >
                        <span class="master-ref-template">{{ t('accommodationMasterRefTemplate') }}:</span>
                        <span class="master-ref-value">{{ formatMasterValue('area') }}</span>
                        <button
                          type="button"
                          class="master-ref-btn"
                          @click="applyMasterField('area')"
                        >
                          {{ t('accommodationMasterRefUseBase') }}
                        </button>
                      </div>
                      <div class="trip-contact-input">
                        <input
                          v-model="internalGoogleContryAndCity"
                          :placeholder="t('accommodationAreaNamePlaceholder')"
                        >
                      </div>
                    </div>
                    
                    <div class="trip-contact-field">
                      <label>{{ t('attractionEditingAddressLabel') }}</label>
                      <div
                        v-if="showMasterFieldReference"
                        class="master-ref-strip"
                      >
                        <span class="master-ref-template">{{ t('accommodationMasterRefTemplate') }}:</span>
                        <span class="master-ref-value">{{ formatMasterValue('address') }}</span>
                        <button
                          type="button"
                          class="master-ref-btn"
                          @click="applyMasterField('address')"
                        >
                          {{ t('accommodationMasterRefUseBase') }}
                        </button>
                      </div>
                      <div class="trip-contact-input">
                        <input
                          v-model="internalAccommodationAddress"
                          :placeholder="t('attractionEditingAddressPlaceholder')"
                          size="lg"
                        >
                      </div>
                    </div>

                    <div class="trip-contact-field">
                      <label>{{ t('website') }}</label>
                      <div
                        v-if="showMasterFieldReference"
                        class="master-ref-strip"
                      >
                        <span class="master-ref-template">{{ t('accommodationMasterRefTemplate') }}:</span>
                        <span class="master-ref-value">{{ formatMasterValue('link') }}</span>
                        <button
                          type="button"
                          class="master-ref-btn"
                          @click="applyMasterField('link')"
                        >
                          {{ t('accommodationMasterRefUseBase') }}
                        </button>
                      </div>
                      <div class="trip-contact-input">
                        <input
                          v-model="internalAccommodationLink"
                          :placeholder="t('attractionEditingWebsitePlaceholder')"
                          class="border-0 shadow text-right"
                          size="lg"
                        >
                      </div>
                    </div>

                    <div class="trip-contact-field">
                      <label>{{ t('attractionEditingNavigationAddressLabel') }}</label>
                      <div class="trip-contact-input">
                        <GlobalMapSerchAutoComplet
                          @handleserchPointChange="handleUpdateSerchPointLocationOnly"
                        >
                        </GlobalMapSerchAutoComplet>
                      </div>
                    </div>
                  </b-collapse>

                      <div class="trip-contact-field">
                    <p v-if="accommodationErrores.length">
                      <label>{{ t('attractionEditingFixFieldsLabel') }}</label>
                      <ul class="input-errors" >
                        <li v-for="( error, index ) in accommodationErrores" :key="index">{{ t(error) }}</li>
                      </ul>
                    </p>
                  </div>
                      <div v-if="haveFormFromRide" class="mt-5 text-right">
                        <a class="trip-default-btn btn-sky" @click="handleSaveAccommodation('update')">{{ t('save') }}</a>
                        <p v-if="pendingSave" class="voucher-save-pending-msg">{{ t('voucherSavePending') }}</p>
                        <a 
                          v-if="this.allRide?.ride?.id"
                          class="trip-default-btn btn-sky btn-greey" 
                          @click="ReturnToSingleRide()">{{ t('attractionEditingBackToTrip') }}</a>
                        <a 
                          v-else
                          class="trip-default-btn btn-sky btn-greey" 
                          @click="gooToRideManagerAttraction()">{{ t('attractionEditingBackToAttractionsEdit') }}</a>
                        <a v-if="!isManagerAccommodationEdit" class="trip-default-btn btn-sky btn-red" @click="this.deleteTheAccommodation">{{ t('accommodationDeleteButton') }}</a>
                      </div>
                      <div v-else class="mt-5 text-right">
                        <a class="trip-default-btn btn-sky" @click="handleSaveAccommodation('create')">{{ t('save') }}</a>
                        <p v-if="pendingSave" class="voucher-save-pending-msg">{{ t('voucherSavePending') }}</p>
                        <a 
                          v-if="this.allRide?.ride?.id"
                          class="trip-default-btn btn-sky btn-greey" 
                          @click="ReturnToSingleRide()">{{ t('attractionEditingBackToTrip') }}</a>
                        <a 
                          v-else
                          class="trip-default-btn btn-sky btn-greey" 
                          @click="gooToRideManagerAttraction()">{{ t('attractionEditingBackToAttractionsEdit') }}</a>
                      </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <PageFooter 
      v-if="!isSubdomain"
    />

    <!-- 16:9 Crop modal -->
    <div v-if="showCropModal" class="crop-modal-overlay" @click.self="cancelCrop">
      <div class="crop-modal">
        <div class="crop-modal-header">
          <h5>{{ t('attractionEditingCropTitle') }}</h5>
          <button type="button" class="crop-modal-close" @click="cancelCrop" aria-label="Close">&times;</button>
        </div>
        <div class="crop-modal-body">
          <div class="crop-mode-toggle">
            <button
              type="button"
              class="crop-mode-btn"
              :class="{ 'is-active': cropMode === 'fill' }"
              @click="cropMode = 'fill'"
            >
              {{ t('attractionEditingCropModeFill') }}
            </button>
            <button
              type="button"
              class="crop-mode-btn"
              :class="{ 'is-active': cropMode === 'fit' }"
              @click="cropMode = 'fit'"
            >
              {{ t('attractionEditingCropModeFit') }}
            </button>
          </div>

          <p class="crop-modal-hint">
            {{ cropMode === 'fill' ? t('attractionEditingCropHint') : t('attractionEditingFitHint') }}
          </p>

          <div class="crop-container">
            <img ref="cropImage" :src="cropImageUrl" alt="Crop" class="crop-image">
          </div>
        </div>
        <div class="crop-modal-footer">
          <button type="button" class="crop-btn crop-btn-cancel" @click="cancelCrop">
            {{ t('attractionEditingCropCancel') }}
          </button>
          <button type="button" class="crop-btn crop-btn-apply" @click="applyCrop">
            {{ t('attractionEditingCropApply') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import GlobalMap from '@/components/GlobalMap';
import { voucherFilename } from '@/utils/voucherFileName';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import { mapActions, mapGetters } from 'vuex';
import PageFooter from "@/components/PageFooter.vue";
import "flatpickr/dist/flatpickr.css";
import firebase from 'firebase/app';
import 'firebase/storage';
import SingleRideHeader from "@/components/SingleRideHeader";
import GlobalMapSerchAutoComplet from '@/components/GlobalMapSerchAutoComplet';
import flatPickr from "vue-flatpickr-component";
import InsertLinkToTextbox from '@/components/InsertLinkToTextbox';
import VoucherUpload from '@/components/VoucherUpload.vue';
import moment from 'moment';
import { translationMixin } from "@/mixins/translationMixin";
import {
  getFloatingItemStyle,
  registerFloatingItem,
  unregisterFloatingItem,
  updateFloatingItem,
} from "@/services/floatingItems";

export default {
  name: 'RideAccommodation',
  mixins: [translationMixin],
  components: {
    SingleRideHeader,
    GlobalMap,
    PageFooter,
    GlobalMapSerchAutoComplet,
    flatPickr,
    InsertLinkToTextbox,
    VoucherUpload,
  },
  data() {
    return {
      sessionToken: null,
      floatingId: "floating-accommodation-choose-hotels",
      uploadValue: 0,
      value: "",
      text: "sdfsdfasdfsdfs",
      lat: 48.2220046,
      lng: 16.3738,
      isAdvancedOptionsOpen: false, // Track collapse state for advanced options
      markerSetForEditMode: false, // Track if marker was set for edit mode
      showMapInfoTooltip: false, // Track map info tooltip visibility
      showInfoTooltip: false,
      isPlaceSelected: false,
      showChangePlaceExplanation: false, // Track explanation tooltip for change place link
      pendingSave: null,
      flatPickrActive: {
        mode: "range",
      },
      flatPickrDisabled: {
        mode: "range",
        enableTime: true,
        defaultDate: ["2019-10-10 10:00", "2019-10-20 13:00"],
      },
      cropMode: 'fill',
      showCropModal: false,
      cropImageUrl: null,
      pendingCropFile: null,
      cropperInstance: null,
      showAccommodationVideo: false,
      accommodationTutorialVideo: {
        videoUrl: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/tutorials%2Fadding_accommodation_5.mp4?alt=media&token=4fe5d3b4-e433-4ecb-9431-abb1a8b8322d',
        loading: false,
        error: false,
      },
    };
  },
  computed: { ...mapGetters([ 'allRide',
                              'email',
                              'password',
                              'accommodationName',
                              'accommodationAddress',
                              'googleContryAndCity',
                              'accommodationText',
                              'accommodationLink',
                              'accommodationImage',
                              'isAccommodationImage',
                              'accommodationCheckIn',
                              'accommodationCheckOut',
                              'haveFormFromRide',
                              'accommodationFormFromRide',
                              'accommodationFormFromBaseRide',
                              'accommodationDayIndex',
                              'accommodationErrores',
                              'accommodationLat',
                              'accommodationLng',
                              'mapWereloded',
                              'appMap',
                              'isUserManager',
                              'isManagerAccommodationEdit',
                              'currentPlace',
                              'referenceMasterAccommodation', ]),
              ...mapGetters("theme",  [ 
                                        "isSubdomain",
                                      ]),

    date:{
      get () {
        const checkIn = this.accommodationCheckIn || '';
        const checkOut = this.accommodationCheckOut || '';
        if (!checkIn && !checkOut) {
          return '';
        }
        // Keep Flatpickr's expected range separator (" to ") for proper parsing in range mode
        return checkIn + ' to ' + checkOut;
      },
      set (value) {
        if (!value || value.trim() === '' || value === ' to ') {
          this.$store.commit('setAccommodationCheckIn', null)
          this.$store.commit('setAccommodationCheckOut', null)
        } else {
          const parts = value.split(' to ');
          this.$store.commit('setAccommodationCheckIn', parts[0] || null)
          this.$store.commit('setAccommodationCheckOut', parts[1] || null)
        }
      }
    },
    accommodationVoucherUrls() {
      return this.$store.getters.accommodationVoucherUrls;
    },
    accommodationVoucherUploadValues() {
      return this.$store.getters.accommodationVoucherUploadValues;
    },
    accommodationOpenText:{
      get () {
        return this.accommodationText;

      },
      set (value) {
        this.$store.commit('setAccommodationText', value)
      }
    },
    internalGoogleContryAndCity:{
      get () {
        return this.googleContryAndCity
      },
      set (value) {
        this.updateAccommodationGoogleContryAndCity( value )
      }
    },
    internalAccommodationName:{
      get () {
        return this.accommodationName
      },
      set (value) {
        this.updateAccommodationName( value )
      }
    },
    internalAccommodationAddress:{
      get () {
        return this.accommodationAddress
      },
      set (value) {
        this.updateAccommodationAddress( value )
      }
    },
    internalAccommodationLink:{
      get () {
        return this.accommodationLink
      },
      set (value) {
        this.updateAccommodationLink( value )
      }
    },
    datePickerConfig() {
      const config = {
        mode: 'range',
        dateFormat: 'd-m-Y'
      };
      
      // Add minDate and maxDate if ride dates are available
      if (this.allRide?.ride?.start_date && this.allRide?.ride?.end_date) {
        // Parse dates from DD-MM-YYYY format
        const startDate = moment(this.allRide.ride.start_date, 'DD-MM-YYYY').toDate();
        const endDate = moment(this.allRide.ride.end_date, 'DD-MM-YYYY').toDate();
        
        config.minDate = startDate;
        config.maxDate = endDate;
      }
      
      return config;
    },

    showMasterFieldReference() {
      return this.referenceMasterAccommodation != null;
    },

    shouldShowFloatingButton() {
      return !!(
        this.isUserManager &&
        this.accommodationDayIndex !== null &&
        !this.isPlaceSelected
      );
    },

    floatingStyle() {
      return getFloatingItemStyle(this.floatingId, { top: "auto", transform: "none" });
    },

  },
  watch: {
    // Watch for lat/lng to be loaded in edit mode
    accommodationLat(newVal) {
      // Only set marker if we're in edit mode, haven't set it yet
      // The markerSetForEditMode flag prevents duplicate markers when dragging
      if (this.haveFormFromRide && !this.markerSetForEditMode && newVal && this.accommodationLng) {
        this.$nextTick(() => {
          this.waitForMapAndSetMarker(newVal, this.accommodationLng);
          this.markerSetForEditMode = true;
        });
      }
    },
    accommodationLng(newVal) {
      // Only set marker if we're in edit mode, haven't set it yet
      // The markerSetForEditMode flag prevents duplicate markers when dragging
      if (this.haveFormFromRide && !this.markerSetForEditMode && this.accommodationLat && newVal) {
        this.$nextTick(() => {
          this.waitForMapAndSetMarker(this.accommodationLat, newVal);
          this.markerSetForEditMode = true;
        });
      }
    },
    shouldShowFloatingButton() {
      this.syncFloatingState();
    },
  },
  methods:
  {
    ...mapActions(['register',
                  'validateAndupdateAppToken',
                  'createAccommodation',
                  'updateTheAccommodation',
                  'deleteTheAccommodation',
                  'uploadAccommodationIfBooked',
                  'ReturnToSingleRide',
                  'setOneMarker',
                  'goToSerchAccommodations']),
    syncFloatingState() {
      this.$nextTick(() => {
        const root = this.$refs.floatingRoot;
        updateFloatingItem(this.floatingId, {
          visible: !!this.shouldShowFloatingButton,
          height: this.shouldShowFloatingButton && root ? root.offsetHeight : 0,
        });
      });
    },

    openCalendar() {
      this.$refs.datePicker.fp.open(); // Programmatically open the calendar
    },

    uploadAccommodationImage(e){
      const files = e.target.files || e.dataTransfer.files;
      const file = files[0];
      if (!file || !file.type.startsWith('image/')) return;

      this.pendingCropFile = file;
      this.cropImageUrl = URL.createObjectURL(file);
      this.showCropModal = true;
      this.$nextTick(() => this.initCropper());

      e.target.value = '';
    },
    initCropper() {
      if (!this.$refs.cropImage || this.cropperInstance) return;
      this.cropperInstance = new Cropper(this.$refs.cropImage, {
        aspectRatio: 16 / 9,
        viewMode: 1,
        dragMode: 'move',
        autoCropArea: 1,
        restore: false,
        guides: true,
        center: true,
        highlight: false,
        cropBoxMovable: true,
        cropBoxResizable: true,
      });
    },
    destroyCropper() {
      if (this.cropperInstance) {
        this.cropperInstance.destroy();
        this.cropperInstance = null;
      }
    },
    cancelCrop() {
      this.destroyCropper();
      if (this.cropImageUrl) {
        URL.revokeObjectURL(this.cropImageUrl);
      }
      this.showCropModal = false;
      this.cropImageUrl = null;
      this.pendingCropFile = null;
      this.cropMode = 'fill';
    },
    applyCrop() {
      if (!this.pendingCropFile) return;

      const uploadBlob = (blob) => {
        if (!blob) return;

        this.destroyCropper();
        if (this.cropImageUrl) URL.revokeObjectURL(this.cropImageUrl);
        this.showCropModal = false;
        this.cropImageUrl = null;
        this.pendingCropFile = null;
        this.cropMode = 'fill';

        const today = new Date();
        const myTime = today.toUTCString().split(', ')[1].split(' ').join('_');

        this.$store.commit('setAccommodationImage', null);
        this.uploadValue = 0;
        this.$store.commit('setAccommodationUploadValue', 0);

        const storageRef = firebase.storage().ref('accommodation/' + this.allRide.ride.id.toString() + '_' + myTime).put(blob);
        storageRef.on('state_changed',
          (snapshot) => {
            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.$store.commit('setAccommodationUploadValue', this.uploadValue);
          },
          (error) => { console.log(error.message); },
          () => {
            this.uploadValue = 100;
            this.$store.commit('setAccommodationUploadValue', 100);
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              this.$store.commit('setAccommodationImage', url);
            });
          }
        );
      };

      if (this.cropMode === 'fit') {
        uploadBlob(this.pendingCropFile);
        return;
      }

      const targetWidth = 1280;
      const targetHeight = 720;

      if (!this.cropperInstance) return;
      const canvas = this.cropperInstance.getCroppedCanvas({
        width: targetWidth,
        height: targetHeight,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      });

      if (!canvas) return;

      canvas.toBlob((blob) => {
        uploadBlob(blob);
      }, 'image/jpeg', 0.9);
    },
    removeImage(){
      this.$store.commit('setAccommodationImage', null);
    },
    handleSaveAccommodation(mode) {
      const voucherRef = this.$refs.accommodationVoucherUpload;
      if (voucherRef && voucherRef.isUploadInProgress()) {
        this.pendingSave = mode;
        return;
      }
      if (mode === 'update') {
        this.updateTheAccommodation();
      } else {
        this.createAccommodation();
      }
    },
    handleAccommodationVoucherUploaded(url) {
      const idx = this.accommodationVoucherUrls.length;
      this.$store.commit('addAccommodationVoucherUrl', url);
      this.$store.commit('clearAccommodationVoucherUploadValue', idx);
      if (this.pendingSave) {
        const mode = this.pendingSave;
        this.pendingSave = null;
        if (mode === 'update') {
          this.updateTheAccommodation();
        } else {
          this.createAccommodation();
        }
      }
    },
    handleAccommodationVoucherUploadProgress(progress) {
      this.$store.commit('setAccommodationVoucherUploadValue', {
        index: this.accommodationVoucherUrls.length,
        value: progress
      });
    },
    removeAccommodationVoucher(index) {
      this.$store.commit('removeAccommodationVoucherUrl', index);
    },
    isVoucherImage(url) {
      if (!url) return false;
      const lower = url.toLowerCase().split('?')[0];
      return ['.jpg', '.jpeg', '.png', '.gif', '.webp'].some(ext => lower.endsWith(ext));
    },
    getVoucherFilename(url) {
      return voucherFilename(url, 'voucher');
    },

    isUplowding(){
      return this.uploadValue > 0
    },
    handleUpdateSerchPointLocationOnly( place ){
      this.updateAccommodationLat( place.geometry.location.lat());
      this.updateAccommodationLng( place.geometry.location.lng());
    },
    
    handleUpdateserchpoint (place) {
      var googleContryAndCity = ''
      if( place.address_components.filter(ac=>~ac.types.indexOf('country')).length > 0 )
        googleContryAndCity = place.address_components.filter(ac=>~ac.types.indexOf('country'))[0].long_name + ", "
      if( place.address_components.filter(ac=>~ac.types.indexOf('locality')).length > 0 ){
        googleContryAndCity += place.address_components.filter(ac=>~ac.types.indexOf('locality'))[0].long_name
      }
      this.updateAccommodationGoogleContryAndCity( googleContryAndCity );
      this.updateAccommodationLat( place.geometry.location.lat());
      this.updateAccommodationLng( place.geometry.location.lng());
      this.$store.commit('setCurrentPlace', place)
    },
    handlePlaceChanged(place) {
      this.handleautoCompliteFormAccommodation(place);
      this.isPlaceSelected = true;
      this.sessionToken = new google.maps.places.AutocompleteSessionToken();
      // Wait for map to load before setting marker
      this.$nextTick(() => {
        if ( place.geometry ){
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          this.waitForMapAndSetMarker(lat, lng);
        }
      });
    },
    handleautoCompliteFormAccommodation (place) {
      this.handleUpdateserchpoint(place)
      this.updateAccommodationName( place.name )
      this.updateAccommodationAddress( place.formatted_address )
      this.updateAccommodationLink( place.website )
      this.updateAccommodationRate( place.rating )
      this.updateAccommodationPlaceId( place.place_id )
      if ( place.geometry ){
        this.$emit("serchPointChange", place);
      }
    },
    returnToPlaceSelection() {
      // Reset to first stage to allow selecting a new place
      this.isPlaceSelected = false;
      this.markerSetForEditMode = false;
      // Optionally clear the marker from the map
      this.$store.dispatch('removeAllMarkersFromGlobalMAp');
    },
    async waitForMapAndSetMarker(lat, lng) {
      // Wait for the map to be loaded
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds max wait
      
      while (attempts < maxAttempts && !this.mapWereloded && !this.appMap) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }
      
      // Wait a bit more to ensure map is fully initialized
      await new Promise(resolve => setTimeout(resolve, 200));
      
      // Now set the marker - setOneMarker already removes all old markers
      if (lat && lng) {
        this.setOneMarker({ 
          latPoint: lat,
          lngPoint: lng,
          name: this.t('accommodationNewPointMarkerName'),
          draggable: true,
          onDragEnd: (newLat, newLng) => {
            // Update lat and lng when marker is dragged
            // Don't trigger watchers by setting a flag
            this.markerSetForEditMode = true;
            this.updateAccommodationLat(newLat);
            this.updateAccommodationLng(newLng);
          }
        });
      }
    },

    updateAccommodationName (value) {
      this.$store.commit('setAccommodationName', value)
    },
    updateAccommodationAddress (value) {
      this.$store.commit('setAccommodationAddress', value)
    },
    updateAccommodationBookingConfirmation (value) {
      this.$store.commit('setAccommodationBookingConfirmation', value)
    },
    updateAccommodationText (value) {
      this.$store.commit('setAccommodationText', value)
    },
    updateAccommodationLink (value) {
      this.$store.commit('setAccommodationLink', value)
    },
    updateAccommodationLat (lat) {
      this.$store.commit('setAccommodationLat', lat)
    },
    updateAccommodationLng (lng) {
      this.$store.commit('setAccommodationLng', lng)
    },
    updateAccommodationImage (value) {
      this.$store.commit('setAccommodationImage', value)
    },
    updateAccommodationGoogleContryAndCity (value) {
      this.$store.commit('setAccommodationGoogleContryAndCity', value)
    },
    gooToRideManagerAttraction(){
      this.$router.push('/ride_manager_attraction')
    },
    updateAccommodationRate ( rate ) {
      this.$store.commit('setAccommodationRate', rate )
    },
    updateAccommodationPlaceId ( placeId ) {
      this.$store.commit('setAccommodationPlaceId', placeId )
    },
    goToSearchAccommodationsFromAccommodationPage() {
      // Navigate to search accommodations with the location from base accommodation and stored day index
      const DEFAULT_LOCATION = { latitude: 48.2220046, longtitude: 16.3738 };
      let location = null;
      const dayIndex = this.accommodationDayIndex;
      const days = this.allRide && this.allRide.attractionsByDay;

      // 1. Base-ride accommodation
      if (this.accommodationFormFromBaseRide && this.accommodationFormFromBaseRide.latitude) {
        location = {
          latitude: this.accommodationFormFromBaseRide.latitude,
          longtitude: this.accommodationFormFromBaseRide.longtitude
        };
      }

      // 2. Last known location in the ride (recursive search backwards through days)
      if (!location && days && dayIndex != null) {
        location = this._findLastRideLocation(days, dayIndex);
      }

      // 3. Default fixed point
      this.goToSerchAccommodations({
        location: location || DEFAULT_LOCATION,
        isRideManager: this.isUserManager,
        dayIndex: dayIndex
      });
    },
    _getActiveAccommodationLocation(day) {
      var acc = Object.keys(day.accommodation || {}).length ? day.accommodation : day.base_trip_accommodation;
      if (acc && acc.latitude) {
        return { latitude: acc.latitude, longtitude: acc.longtitude };
      }
      return null;
    },
    _findLastRideLocation(days, dayIndex) {
      if (dayIndex < 0 || !days[dayIndex]) { return null; }

      var accLocation = this._getActiveAccommodationLocation(days[dayIndex]);
      if (accLocation) { return accLocation; }

      // Check the last attraction of this day with a valid location
      var attractions = days[dayIndex].daily_attractions || [];
      for (var i = attractions.length - 1; i >= 0; i--) {
        if (attractions[i].latitude) {
          return { latitude: attractions[i].latitude, longtitude: attractions[i].longtitude };
        }
      }

      // Nothing on this day - recurse to the previous day
      return this._findLastRideLocation(days, dayIndex - 1);
    },
    toggleAccommodationVideo() {
      if (this.showAccommodationVideo) {
        const ref = this.$refs.accommodationVideo;
        if (ref) {
          ref.pause();
          ref.currentTime = 0;
        }
        this.showAccommodationVideo = false;
        return;
      }
      this.showAccommodationVideo = true;
      this.accommodationTutorialVideo.loading = true;
      this.accommodationTutorialVideo.error = false;
      this.$nextTick(() => {
        const ref = this.$refs.accommodationVideo;
        if (ref && ref.load) ref.load();
      });
    },
    onAccommodationVideoLoadStart() {
      this.accommodationTutorialVideo.loading = true;
    },
    onAccommodationVideoLoaded() {
      this.accommodationTutorialVideo.loading = false;
    },
    onAccommodationVideoError() {
      this.accommodationTutorialVideo.loading = false;
      this.accommodationTutorialVideo.error = true;
    },
    retryAccommodationVideo() {
      this.accommodationTutorialVideo.error = false;
      this.accommodationTutorialVideo.loading = true;
      this.$nextTick(() => {
        const ref = this.$refs.accommodationVideo;
        if (ref && ref.load) ref.load();
      });
    },
    formatMasterValue(field) {
      const m = this.referenceMasterAccommodation;
      if (!m) {
        return '';
      }
      switch (field) {
        case 'name':
          return m.name != null && m.name !== '' ? String(m.name) : '-';
        case 'address':
          return m.address != null && m.address !== '' ? String(m.address) : '-';
        case 'area':
          return m.cuntry_and_city != null && m.cuntry_and_city !== '' ? String(m.cuntry_and_city) : '-';
        case 'text':
          return m.text != null && m.text !== '' ? String(m.text) : '-';
        case 'link':
          return m.link != null && m.link !== '' ? String(m.link) : '-';
        case 'dates': {
          const a = m.check_in_date;
          const b = m.check_out_date;
          if (!a && !b) {
            return '-';
          }
          if (a && b) {
            return `${a} ${this.t('accommodationDateRangeSeparator')} ${b}`;
          }
          return String(a || b || '-');
        }
        case 'location': {
          const parts = [];
          if (m.address) {
            parts.push(String(m.address));
          }
          if (m.latitude != null && m.longtitude != null) {
            parts.push(`(${m.latitude}, ${m.longtitude})`);
          }
          return parts.length ? parts.join(' · ') : '-';
        }
        default:
          return '-';
      }
    },
    async applyMasterField(field) {
      const m = this.referenceMasterAccommodation;
      if (!m) {
        return;
      }
      switch (field) {
        case 'name':
          this.updateAccommodationName(m.name || '');
          break;
        case 'address':
          this.updateAccommodationAddress(m.address || '');
          break;
        case 'area':
          this.updateAccommodationGoogleContryAndCity(m.cuntry_and_city || '');
          break;
        case 'text':
          this.updateAccommodationText(m.text || '');
          break;
        case 'link':
          this.updateAccommodationLink(m.link || '');
          break;
        case 'dates':
          this.$store.commit('setAccommodationCheckIn', m.check_in_date || null);
          this.$store.commit('setAccommodationCheckOut', m.check_out_date || null);
          break;
        case 'location':
          this.updateAccommodationAddress(m.address || '');
          this.updateAccommodationGoogleContryAndCity(m.cuntry_and_city || '');
          if (m.place_id != null && m.place_id !== '') {
            this.updateAccommodationPlaceId(m.place_id);
          }
          if (m.latitude != null && m.longtitude != null) {
            const lat = parseFloat(String(m.latitude));
            const lng = parseFloat(String(m.longtitude));
            if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
              this.markerSetForEditMode = false;
              this.updateAccommodationLat(lat);
              this.updateAccommodationLng(lng);
              await this.waitForMapAndSetMarker(lat, lng);
              this.markerSetForEditMode = true;
            }
          }
          break;
        default:
          break;
      }
    },
  },
  created() {
    // if we arive to this page after sertching we should remove the last information
    this.$store.commit('setCurrentPlace', null)
    
    this.uploadAccommodationIfBooked();
    this.$store.dispatch('removeAllMarkersFromGlobalMAp');
    // If editing an existing accommodation, show all fields immediately
    if (this.haveFormFromRide) {
      this.isPlaceSelected = true;
      // Check if lat/lng are already loaded
      if (this.accommodationLat && this.accommodationLng) {
        this.$nextTick(() => {
          this.waitForMapAndSetMarker(this.accommodationLat, this.accommodationLng);
          this.markerSetForEditMode = true;
        });
      }
      // Otherwise, the watcher will handle it when lat/lng are loaded
    }
    // If we have base ride accommodation with populated fields (from search results), show all fields immediately
    if (this.accommodationFormFromBaseRide && Object.keys(this.accommodationFormFromBaseRide).length > 0 && this.accommodationName) {
      this.isPlaceSelected = true;
      // Check if lat/lng are available from the base accommodation
      const lat = this.accommodationFormFromBaseRide.latitude;
      const lng = this.accommodationFormFromBaseRide.longtitude;
      if (lat && lng) {
        this.$nextTick(() => {
          this.waitForMapAndSetMarker(parseFloat(lat), parseFloat(lng));
          this.markerSetForEditMode = true;
        });
      }
    }
   },
  beforeDestroy() {
    unregisterFloatingItem(this.floatingId);
    this.cancelCrop();
    this.$store.commit('setReferenceMasterAccommodation', null);
    this.$store.commit('setAccommodationSaveReturnToRide', false);
  },
  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      this.sessionToken = new google.maps.places.AutocompleteSessionToken();
    });
    this.$store.dispatch('removeAllMarkersFromGlobalMAp');
    registerFloatingItem({ id: this.floatingId, priority: 35, anchor: "right", zIndex: 999 });
    this.syncFloatingState();
   },
};
</script>

<style scoped>

.master-ref-banner {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.7;
  color: #0a3d6b;
  background: #dbeeff;
  border: 2px solid #5aabf0;
  border-radius: 10px;
  padding: 16px 18px;
  margin-bottom: 16px;
  white-space: pre-line;
  box-shadow: 0 2px 8px rgba(90, 171, 240, 0.18);
}

.master-ref-strip {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  font-size: 14px;
  margin-bottom: 8px;
  padding: 8px 10px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}

.master-ref-strip-map {
  margin-top: 10px;
}

.master-ref-template {
  font-size: 14px;
  font-weight: 600;
  color: #444;
  flex-shrink: 0;
}

.master-ref-value {
  font-size: 14px;
  flex: 1 1 180px;
  color: #1e1e1e;
  word-break: break-word;
  min-width: 0;
}

.master-ref-btn {
  flex-shrink: 0;
  cursor: pointer;
  background: #fff;
  border: 1px solid #07a0c3;
  color: #07a0c3;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 600;
}

.master-ref-btn:hover {
  background: #e8f7fb;
}

.btn-greey {
  background: #6c757d!important;
  border-color: #6c757d!important;
  color: #fff!important;
}

[dir="ltr"] .row {
  flex-direction: row !important;
}

[dir="ltr"] .trip-contact-wrap,
[dir="ltr"] .trip-contact-column,
[dir="ltr"] .trip-contact-field,
[dir="ltr"] .trip-contact-field label,
[dir="ltr"] .map-explanation,
[dir="ltr"] .map-explanation-title,
[dir="ltr"] .map-info-tooltip,
[dir="ltr"] .info-tooltip,
[dir="ltr"] .change-place-explanation,
[dir="ltr"] .explanation-title,
[dir="ltr"] .explanation-content {
  text-align: left !important;
  direction: ltr !important;
}

[dir="ltr"] .trip-contact-input input,
[dir="ltr"] .trip-contact-input textarea,
[dir="ltr"] ::v-deep .gmap-autocomplete input {
  text-align: left !important;
  direction: ltr !important;
}

[dir="rtl"] .trip-contact-input input.flatpickr-input {
  text-align: right !important;
  direction: rtl !important;
}

.accommodation-date-row {
  align-items: center;
  gap: 0.75rem;
}

.accommodation-date-row img.coulunder_image {
  margin: 0 !important;
}

[dir="rtl"] .accommodation-date-row img.coulunder_image {
  order: 2;
}

[dir="rtl"] .accommodation-date-row .flatpickr-input {
  order: 1;
}

[dir="ltr"] .accommodation-date-row img.coulunder_image {
  order: 2;
}

[dir="ltr"] .accommodation-date-row .flatpickr-input {
  order: 1;
}

[dir="ltr"] .trip-contact-field label {
  margin-right: 0 !important;
  margin-left: 40px !important;
}

[dir="ltr"] .trip-contact-field label small {
  float: right !important;
}

.autocomplete-intro {
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 500;
  color: #0D2F29;
  line-height: 1.6;
}

[dir="rtl"] .autocomplete-intro {
  text-align: right;
  direction: rtl;
}

[dir="ltr"] .autocomplete-intro {
  text-align: left;
  direction: ltr;
}

.accommodation-reco-intro {
  margin-bottom: 1em;
  font-size: 1.5rem;
}

[dir="rtl"] .accommodation-reco-intro {
  text-align: right;
  direction: rtl;
}

[dir="ltr"] .accommodation-reco-intro {
  text-align: left;
  direction: ltr;
}

[dir="rtl"] .accommodation-reco-box {
  text-align: right;
  direction: rtl;
}

[dir="ltr"] .accommodation-reco-box {
  text-align: left;
  direction: ltr;
}

[dir="ltr"] .accommodation-reco-box ul {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

[dir="ltr"] .trip-input-icon {
  right: auto !important;
  left: 25px !important;
}

[dir="ltr"] .map-info-tooltip {
  right: auto !important;
  left: 0 !important;
}

[dir="ltr"] .explanation-content ul {
  padding-right: 0 !important;
  padding-left: 20px !important;
}

[dir="ltr"] .explanation-content ul li {
  padding-right: 0 !important;
  padding-left: 20px !important;
}

[dir="ltr"] .explanation-content ul li:before {
  right: auto !important;
  left: 0 !important;
}


.btn-red {
  background: red;
  color: black;
}

.btn-green {
  background: #0B6758;
  color: #fff;
}

.after_page_header{
  margin-top: 23rem;
}

.brightness {
    background-color: white;
    display: inline-block;

}
.brightness img:hover {
    opacity: .5;
}
img{margin:10px;}
.selected{
  box-shadow:0px 12px 22px 1px #333; border:solid 3px yellow;
}

.input-errors{
  color: rgba(255, 0, 0, 1);
  font-size: 16px;
  padding: 0 1rem;
}

.container {
  padding: 0 1.5rem ;
}

.row {
  flex-direction: row-reverse;
}

/* activity page */
.trip-card-top {
  text-align: center;
  margin-bottom: 25px;
}
a.trip-btn-bg {
  display: inline-block;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #FFFFFF;
  background: #07A0C3;
  border-radius: 45px;
  padding: 9px 38px;
  margin-right: 50px;
}
a.trip-btn-outline {
  background: #FFFFFF;
  border: 1px solid #07A0C3;
  border-radius: 45px;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: rgba(13, 47, 41, 0.5);
  display: inline-block;
  width: 500px;
  padding: 6px 38px;
}
a.trip-btn-outline img{
  margin-left: 10px;
}
.trip-map-four {
  position: sticky;
  top: 237px;
}

.trip-card2-thumb {
  height: 232px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F7F7F7;
}
.trip-card2-thumb img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}
.trip-card2-thumb.plus img{
  width: auto;
  height: auto;
}

.trip-card2-wrap {
  margin: 0 25px;
}
.trip-card2-data {
  background: rgba(13, 47, 41, 0.3);
  text-align: center;
  padding: 16px;
  transition: all 0.4s;
}
.col-lg-4.col-sm-6:nth-child(1) .trip-card2-data{
  background: rgba(13, 47, 41, 0.3);
}
.col-lg-4.col-sm-6:nth-child(2) .trip-card2-data{
  background: #07A0C3;
}
.col-lg-4.col-sm-6:nth-child(3) .trip-card2-data{
  background: #0AD6A1;
}
.trip-card2-wrap:hover .trip-card2-data{
  background-color: #07A0C3;
}
.trip-card2-data h3{
  font-weight: 700;
  font-size: 18px;
  color: #FFFFFF;
}

.trip-activity-section {
  padding: 30px 0 80px;
}
.trip-activity-section .trip-sidebar {
  margin-left: 100px;
}

.trip-activity-section .trip-card-content {
  padding-left: 10px;
}
.trip-activity-section .trip-card-footer{
  padding: 0;
}
a.trip-card-btn {
  background: rgba(13, 47, 41, 0.5);
  border-radius: 45px;
  display: inline-block;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  padding: 6px 19px;
  transition: all 0.4s;
}
a.trip-card-btn:hover{
  background-color: #0A816D;
}
.trip-activity-section .trip-card-wrap {
  border: 5px solid #000;
  transition: all 0.4s;
  margin-bottom: 30px;

}
.trip-activity-section .trip-card-wrap:hover {
  border: 5px solid #07A0C3;

}
.trip-location {
  margin-right: 143px;
}
.trip-location ul li{
  font-size: 20px;
  color: #0D2F29;
  position: relative;
  margin-bottom: 15px;
  padding-right: 35px;
  text-align: right;
}
.trip-location ul li img{
  width: 22px;
  position: absolute;
  right: 0;
}

.trip-activity-top h4 {
  font-weight: 600;
  font-size: 24px;
  line-height: 33px;
  text-align: center;
  color: #0D2F29;
  border-bottom: 2px solid #0D2F29;
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.trip-activity-map {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 30px;
}

.trip-activity-map h6 {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: rgba(13, 47, 41, 0.5);
  margin: 0;
  margin-right: 20px;
}
.trip-activity-map h6 img{
  margin-left: 7px;
}
.trip-activity-map h5 {
  width: 120px;
  height: 24px;
  background: #000000;
  border: 1px solid rgba(13, 47, 41, 0.5);
  border-radius: 45px;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #FFFFFF;
  margin: 0;
}

.trip-contnet-section.mobile-device{
  display: none;
}

.trip-location.mobile-device{
  display: none;
}
.trip-hero-section.activity-page {
  padding: 120px 0 55px;
}
/* modal */
.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 45px 55px;
}
.modal-dialog {
  max-width: 310px;

  margin: 1.75rem auto!important;
  margin-top: 10%!important;

}
.modal-content {
  background: #FFFFFF;
  box-shadow: 4px 4px 4px rgb(0 0 0 / 10%);
  border-radius: 25px;
}
.trip-login-wrap{
  text-align: center;
}
.trip-login-field{
  margin-bottom: 10px;
}
.trip-login-field input{
  height: 30px;
  width: 100%;
  text-align: right;
  border: 1px solid #C1C0C0;
  border-radius: 22px;
  font-size: 12px;
  line-height: 14px;
  padding: 5px 15px!important;

  color: #C1C0C0;
}
button#trip-login-btn,
button#trip-login-btn2 {
  width: 100%;
  height: 30px;
  background: #34D0B6;
  border-radius: 22px;
  border: none;
  font-weight: 500;
  font-size: 12px;
  color: white;
  margin-top: 15px;
}
button#trip-login-btn2{
  background-color:  #07A0C3;
}

.trip-login-wrap h3{
  font-weight: 800;
  font-size: 18px;
  line-height: 21px;
  color: #2E2E3A;
  margin-bottom: 15px;
  text-align: center
}
.trip-border-content{
  text-align: center;
  margin-top: 20px;
  margin-bottom: 12px;
}
.trip-border-content p{
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
  text-align: center;
  position: relative;
  z-index: 0;
  display: inline-block;
  background-color: #fff;
}
.trip-border-content p:before,
.trip-border-content p:after {
  content: " ";
  left: -60px;
  top: 7px;
  width: 87%;
  height: 1px;
  display: inline;
  position: absolute;
  background-color: #2E2E3A;
  z-index: -1;
}
.trip-border-content p:after{
  left: auto;
  right: -60px;
}
.trip-login-bottom-btn{
  margin-top: 25px;
}
.trip-login-bottom-btn h5{
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
  margin-bottom: 5px;
}

button.trip-login-btn {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #FFFFFF;
  width: 129px;
  height: 30px;
  background: #07A0C3;
  border-radius: 22px;
  border: none;
}
.trip-login-check {
  text-align: right;
}
.trip-login-check h5{
  font-size: 9px;
  line-height: 11px;
  text-align: right;
  color: #2E2E3A;
  margin-top: 7px;
}
.trip-login-check label{
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
}
.trip-login-check input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.trip-login-check label {
  position: relative;
  cursor: pointer;
}

.trip-login-check label:before {
  content:'';
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #2E2E3A;
  padding: 0 6.5px;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-left: 5px;
  border-radius: 3px;
}

.trip-login-check input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 3px;
  right: 6px;
  width: 5px;
  height: 8px;
  border: solid #2E2E3A;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
/* contact page */
.trip-card-top.trip-card-top2{
  text-align: left;
  position: relative;
}
.trip-card-top h4 {
  font-weight: 600;
  font-size: 30px;
  line-height: 41px;
  color: #0D2F29;
  display: inline-block;
  position: absolute;
  top: 0;
  margin: 0;
  left: 50%;
  transform: translateX(-50%);
}
.trip-contact-wrap h4{
  display: none;
}
.trip-contact-field {
  margin-bottom: 15px;
}
.map-explanation {
  margin-bottom: 15px;
  text-align: right;
  direction: rtl;
  position: relative;
}
.map-explanation-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #0D2F29;
  margin: 0 0 0 0;
  text-align: right;
}
.map-explanation-title .info-icon {
  cursor: pointer;
  margin-right: 8px;
  font-size: 20px;
  display: inline-block;
  vertical-align: middle;
  transition: transform 0.2s;
}
.map-explanation-title .info-icon:hover {
  transform: scale(1.1);
}
.map-info-tooltip {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 1000;
  min-width: 300px;
  max-width: 400px;
  font-size: 14px;
  line-height: 1.6;
  color: #495057;
  text-align: right;
  direction: rtl;
}
.trip-contact-field label{
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: right;
  color: rgba(13, 47, 41, 0.5)!important;
;
  display: block;
  margin-bottom: 5px;
  margin-right: 40px;
  }
  .trip-contact-field label span{
    color: #E42424;
  }

  .trip-contact-input{
    position: relative;
  }
  .trip-contact-field img{
    width: 100%;
  }
  .trip-contact-input input,
  .trip-contact-input textarea{
    height: 56px;
    width: 100%;
    background: #FFFFFF;
    border: 2px solid #07A0C3!important;
    border-radius: 45px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: right;
    padding: 10px 20px!important;
    color: black !important;

  }
  .trip-contact-input textarea{
    height: 300px;
  }
  .trip-input-icon {
    position: absolute;
    top: 13px;
    right: 25px;
  }
  .trip-contact-input p{
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    margin:15px 0 0;
    color: rgba(228, 36, 36, 0.6)
  }
.trip-contact-input input::-webkit-input-placeholder,
.trip-contact-input textarea::-webkit-input-placeholder{ /* WebKit, Blink, Edge */
    color: rgba(13, 47, 41, 0.5);
    opacity: 1;
}
.trip-contact-input input:-moz-placeholder,
.trip-contact-input textarea:-moz-placeholder{ /* Mozilla Firefox 4 to 18 */
  color: rgba(13, 47, 41, 0.5);
   opacity:  1;
}
.trip-contact-input input::-moz-placeholder,
.trip-contact-input textarea::-moz-placeholder{ /* Mozilla Firefox 19+ */
  color: rgba(13, 47, 41, 0.5);
   opacity:  1;
}
.trip-contact-input input:-ms-input-placeholder,
.trip-contact-input textarea:-ms-input-placeholder{ /* Internet Explorer 10-11 */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}
.trip-contact-input input::-ms-input-placeholder,
.trip-contact-input textarea::-ms-input-placeholder{ /* Microsoft Edge */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}

.trip-contact-input input::placeholder,
.trip-contact-input textarea::placeholder{ /* Most modern browsers support this now. */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}

button#submit-btn1 {
  height: 56px;
  background: #0D2F29;
  border-radius: 12px;
  width: 100%;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: #FFFFFF;
}
.submit-btn-back {
  background: #6c757d!important;
  color: white!important;
}

button#submit-btn2 {
    width: 188px;
    height: 42px;
    background: #DD6E42;
    border-radius: 45px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    margin: 0 auto;
}

.trip-submit-button{
  margin-top: 50px;
  text-align: center;
}

.trip-contact-form-section {
  padding-bottom: 150px;
}
.trip-contact-siderbar{
  background: rgba(225, 246, 251, 0.5);
  border-radius: 18px;
  padding: 25px;
  margin-left: 50px;
}
.trip-contact-siderbar h5{
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #E42424;
}

.trip-card2-thumb-resposive {
  display: none;
}
.trip-card2-thumb-resposive img{
  width: 100%;
  height: 100%;
}

.close-icon {
  border: 1px solid transparent;
  background-color: transparent;
  display: inline-block;
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
  position: absolute;
  left: 13px;
  top: 13px;
  font-weight: 800;
  font-size: 18px;
  line-height: 24px;
  text-align: right;
  color: #FF0000;
}
.close-icon img{
  width: auto;
}
.input-remove:not(:valid) ~ .close-icon {
	display: none;
}


/* updloade img */


.btn_upload {
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  position: relative;
  padding: 5px 10px;
  height: 198px;
  background: #FFFFFF;
  border: 2px solid #07A0C3;
  border-radius: 45px;
  width: 100%;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: right;
  color: #0D2F29;
  padding-right: 66px;
  padding-top: 13px;
}

[dir="ltr"] .btn_upload {
  text-align: left;
  direction: ltr;
  padding-right: 11px;
  padding-left: 87px;
}

.btn_upload:hover,
.btn_upload:focus {
  background-color: none;
}


.btn_upload input {
  cursor: pointer;
  height: 100%!important;
  position: absolute;
  filter: alpha(opacity=1);
  -moz-opacity: 0;
  opacity: 0;
  left: 0;
  top: 0;
  z-index: 99;
}


.preview1.it {
  position: absolute;
  top: 29px;
  width: 150px!important;
  height: 150px;
  left: 50%;
  transform: translateX(-50%);
}

.btn-rmv1{
  display: none;
}

.rmv {
  cursor: pointer;
  color: #fff;
  border-radius: 30px;
  display: inline-block;
  position: absolute;
  right: 38%;
  top: 34px;
  z-index: 999;
  border: navajowhite;
  background-color: transparent;
  font-size: 32px;
}
img#ImgPreview {
  position: absolute;
  text-indent: 66em;
}













/*For bigger screen then normal 1500px desktop*/

@media (min-width: 1500px) {
    .container {
      max-width: 1360px;
    }
  }
  @media only screen and (max-width: 1399px) {
    .main-menu ul li{
        margin: 0 14px;
    }
    .main-menu ul li a{
        font-size: 16px;
    }
  }

  @media (min-width: 991px) {
      header.trip-header-section.sticky-menu {
          opacity: 0;
        }
        .trip-hero-section.sticky-menu{
          padding: 20px 0 0;
        }
    }

  @media (min-width: 1200px) and (max-width: 1499px) {
      .trip-sidebar{
          margin: 0;
      }

      .trip-activity-section .trip-sidebar {
          margin-left: 0;
      }
      a.trip-card-btn {
          padding: 6px 15px;
      }

  }


  @media only screen and (max-width: 1199px) {
      a.trip-header-social {
          display: none;
      }
      .main-menu ul li {
          margin: 0 15px;
      }
      .main-menu {
          margin-right: 30px;
      }
      .trip-sidebar{
          margin: 0;
      }
      .trip-card-footer {
          padding-left: 20px;
      }

      a.trip-card-btn {
          padding: 5px 10px;
      }
      .trip-location {
          margin-right: 0;
      }
      .trip-activity-section .trip-sidebar {
        margin-left: 30px;
    }
    .trip-card2-wrap {
        margin: 0 10px;
    }
    .trip-card2-data h3 {
        font-size: 16px;
    }

  }



  /*For Tablet Layout*/
  @media(max-width: 991px) {
      .main-menu {
          display: none;
      }
      .offcanves-menu{
          display: block;
      }
      .menu-bar{
          display: block;
      }
      .trip-menu-wrap {
          display: block;
          text-align: left;
          margin-left: 50px;
      }
      .trip-card2-wrap {
          margin: 0;
      }
      .trip-card2-data h3 {
          font-size: 18px;
      }
      a.trip-btn-outline {
          width: 400px;
      }

      .trip-location {
          display: none;
      }

  .trip-location.mobile-device{
      display: block;
      text-align: center;
    }
    .trip-location.mobile-device ul li{
      margin: 0 19px;
      font-size: 16px;
      display: inline-block;
    }
    .trip-activity-map {
      justify-content: center;
      margin-bottom: 14px;
      margin-top: 30px;
  }
  .trip-activity-section .trip-sidebar {
      margin-left: 0;
  }

  header.trip-header-section {
      padding: 18px 0;
      top: 0;
      background-color: white;
  }



  /* activity */
  .trip-hero-section.activity-page {
      padding: 109px 0 30px;
      margin-top: 0;
  }
  .trip-map-four {
      display: none;
  }

  .trip-hero-section.trip-page {
      padding: 110px 0 35px;
      margin: 0;
  }
  .trip-hero-section.home2 {
      margin: 0;
  }
  .trip-hero-section.home2 {
      padding: 95px 0 20px;
  }
  .trip-date-section.home2 {
      padding: 40px 0;
  }
  .trip-iconbox-section {
      padding: 60px 0 30px;
  }
  .trip-iconbox-wrap {
      margin-bottom: 30px;
  }

  .trip-card2-wrap {
    margin: 0 0 15px;
  }
  .trip-contact-siderbar{
    margin: 0 0 10px;
  }

  }


  /*For Wide Mobile Layout*/
  @media (max-width: 767px) {
      a.trip-header-btn {
          margin-right: 0;
      }
      .trip-logo {
          display: inline-block;
          width: 150px;
      }
      .trip-card-body {
          display: block;
      }
      .trip-card-thumb img{
          width: 100%;
      }
      .trip-card-thumb{
          margin-bottom: 20px;
      }

      a.trip-btn-outline {
          width: 270px;
      }
      .trip-card2-data h3 {
        font-size: 10px;
    }
    .trip-card2-thumb.plus img{
        width: 48px;
        height: 48px;
    }


    /* contact page */
    .trip-card-top h4{
        opacity: 0;
    }
    .trip-contact-wrap h4 {
        display: block;
        font-weight: 600;
        font-size: 25px;
        line-height: 19px;
        text-align: center;
        color: #0D2F29;
    }

    .trip-card-top.trip-card-top2{
        margin: 0;
        padding-bottom: 15px;
    }

    .trip-contact-siderbar h5 {
        font-size: 12px;
        line-height: 16px;
    }
    .trip-contact-siderbar {
        padding: 10px 50px;
    }
    .trip-contact-field label {
        font-size: 12px;
    }
    .trip-contact-input input,
    .trip-contact-input textarea {
        font-size: 16px;
        line-height: 22px;
        padding: 10px 30px!important;
    }
    .trip-contact-input input {
        height: 44px;
    }
    .trip-contact-input textarea{
        height: 94px;
        border-radius: 15px;
    }
    .map-explanation {
        margin-bottom: 10px;
    }
    .map-explanation-title {
        font-size: 16px;
        line-height: 22px;
    }
    .map-explanation-title .info-icon {
        font-size: 18px;
        margin-right: 6px;
    }
    .map-info-tooltip {
        min-width: 250px;
        max-width: 320px;
        padding: 12px;
        font-size: 12px;
        margin-top: 6px;
    }
    .trip-input-icon {
        top: 12px;
        right: 15px;
    }
    .trip-input-icon img{
        width: 12px;
    }

    .trip-contact-input p {
        font-size: 12px;
        margin: 6px 0 0;
    }
    button#submit-btn1 {
        height: 30px;
        font-size: 12px;
        line-height: 21px;
    }
    button#submit-btn2 {
        height: 30px;
        font-size: 14px;
    }
    .trip-submit-button {
        margin-top: 15px;
    }
    .trip-contact-form-section {
        padding-bottom: 30px;
    }

    .close-icon {
        top: 2px;
        font-size: 12px;

    }
    .close-icon img{
        width: 12px;
    }
    .btn_upload {
        font-size: 12px;

    }
    .btn_upload {
        height: 100px;
        padding-right: 40px;
    }
    .preview1.it {
        top: 22px;
        width: 60px!important;
        height: 60px;
    }
    .rmv {
        right: 44%;
        top: 21px;
        font-size: 12px;
    }
    .trip-input-icon.trip-input-icon2 {
        top: 12px;
        right: 22px;
    }


  }

  @media (max-width: 667px) {
      .trip-hero-section {
          padding: 5px 0 13px;
      }

      .responsive-width-left{
          width: 30%;
      }
      .responsive-width-right{
          width: 70%;
      }
      .trip-hero-content h1 {
          font-size: 16px;
          margin-bottom: 3px;
      }
      .map-icon {
          width: 20px;
          margin-left: 5px;
      }
      .trip-social ul li a img{
          width: 40px;
      }

  .trip-contnet-section{
      display: none;
  }

  .menu-bar {
      color: #000;
  }

  a.trip-btn-bg {
      font-size: 12px;
      padding: 5px 30px;
      margin-right: 20px;
  }
  a.trip-btn-outline {
      width: 170px;
      padding: 3px 38px;
      font-size: 14px;
  }
  a.trip-btn-outline img {
      margin-left: 10px;
      width: 17px;
  }
  .trip-card-top {
      text-align: center;
      margin-bottom: 20px;
  }

  .trip-card2-data {
      padding: 7px;
  }
  .trip-card2-thumb{
    display: none;
  }
  .trip-activity-top h4 {
      font-size: 16px;
      margin-bottom: 15px;
      padding-bottom: 2px;
  }
  .trip-location.mobile-device ul li {
      margin: 0 7px;
      font-size: 12px;
      padding-right: 20px;
  }
  .trip-location ul li img {
      width: 15px;
  }
  .trip-activity-map {
      margin-top: 15px;
  }
  .trip-card-header h4 {
      font-size: 16px;
  }
  .trip-card-content p {
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
  a.trip-card-btn {
      padding: 3px 14px;
      font-size: 12px;
  }
  .trip-card2-thumb {
    height: 130px;
}


  /* footer */
  footer.trip-footer-section {
      padding: 14px 0;
  }
  .footer-menu ul li {
      padding: 0;
      display: block;
      line-height: 1;
  }
  .footer-menu ul li a{
      font-size: 12px;
  }
  .footer-menu ul li:before {
      content: none;
  }
  .trip-footer-wrap img {
      margin-bottom: 9px;
      width: 110px;
  }

  /* ctivity */
  .trip-hero-section.activity-page {
      padding: 95px 0 15px;
  }
  .trip-sidebar-item-top {
      display: flex;
      text-align: center;
      justify-content: space-between;
  }
  .trip-sidebar-item-top.desktop{
      display: none;
    }
    .trip-sidebar-item-top.mobile {
      display: flex;
  }

  .trip-cta2-section {
      padding: 30px 0 10px;
  }
  .trip-cta2-wrap {
      margin-bottom: 20px;
  }
  .trip-cta2-title h2 {
      font-size: 14px;
      margin-bottom: 30px;
  }
  .trip-cta2-data p {
      font-size: 14px;
      line-height: 18px;
  }
  .trip-cta2-thumb img {
      width: 100px;
      height: 100%;
  }

  .trip-iconbox-thumb {
      height: auto;
  }
  .trip-iconbox-thumb img {
      width: 100px;
  }
  .trip-iconbox-data h3 {
      font-size: 14px;
      line-height: 18px;
  }
  .trip-iconbox-data p {
      font-size: 12px;
      line-height: 20px;
  }
  .trip-social ul li {
      margin: 0 12px;
  }
  .trip-login-wrap h3 {
    margin-bottom: 15px;
}
.trip-card2-thumb.plus {
    height: 90px;
    display: flex;
}
.trip-card2-thumb-resposive {
    display: block;
}


  }

  @media (max-width: 575px) {
    .responsive-width{
        width: 50%;
        margin: 0 auto;
    }
    .trip-card2-data h3 {
        font-size: 9px;
    }

  }

  /*For 320-384px up Mobile Layout*/
  @media (max-width: 479px) {

    .trip-card-footer {
          padding-left: 0;
      }
      .trip-card-body {
          padding: 7px 10px 20px;
      }

      .trip-card-header {
          display: block;
          text-align: center;
      }
      .trip-card-header h4 {
          margin-top: 15px;
      }

      a.trip-hero-btn {
          font-size: 12px;
      }

  }
  @media (max-width: 400px){
      .trip-menu-wrap {
          margin-left: 25px;
      }
  }

.info-tooltip {
  position: absolute;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 12px;
  max-width: 350px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 1000;
  font-size: 1.1em;
  line-height: 1.5;
}

.change-place-explanation {
  right: 0;
  top: 100%;
  margin-top: 8px;
  text-align: right;
  direction: rtl;
}

/* Style for the autocomplete input */
::v-deep .gmap-autocomplete input {
  width: 100%;
  padding: 16px;
  border: 2px solid #ddd;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 1.2em;
  background-color: #fff;
}

::v-deep .gmap-autocomplete input:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74,144,226,0.2);
}

.explanation-box {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  font-size: 1.2em;
}

.explanation-section {
  margin-bottom: 16px;
}

.explanation-section:last-child {
  margin-bottom: 0;
}

.explanation-title {
  color: #2c3e50;
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 1.1em;
}

.explanation-content {
  color: #495057;
  line-height: 1.6;
}

.explanation-content ul {
  margin: 8px 0 8px 20px;
  padding: 0;
  list-style-type: none;
}

.explanation-content ul li {
  margin: 4px 0;
  position: relative;
  padding-right: 20px;
}

.explanation-content ul li:before {
  content: "•";
  position: absolute;
  right: 0;
  color: #4a90e2;
}

.important-note {
  background-color: #fff3cd;
  border-radius: 6px;
  padding: 12px;
  margin-top: 16px;
}

.important-note .explanation-title {
  color: #856404;
}

.important-note .explanation-content {
  color: #856404;
}

.icon {
  margin-left: 8px;
}

/* 16:9 preview and crop modal - same as AttractionEditing */
.image-preview-wrapper {
  position: relative;
  margin-top: 16px;
}

.image-preview-16-9 {
  aspect-ratio: 16/9;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(
    135deg,
    rgba(7, 160, 195, 0.06) 0%,
    rgba(52, 208, 182, 0.08) 50%,
    rgba(7, 160, 195, 0.06) 100%
  );
  border-radius: 18px;
}

.image-preview-16-9 .attraction-image-top-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: blur(24px);
  transform: scale(1.15);
  z-index: 0;
}

.image-preview-16-9 .attraction-image-top-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: relative;
  z-index: 1;
}

.rmv {
  right: 16px;
  top: 16px;
}

.crop-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.crop-modal {
  background: #fff;
  border-radius: 12px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.crop-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
}

.crop-modal-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #0D2F29;
}

.crop-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  line-height: 1;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
}

.crop-modal-close:hover {
  color: #0D2F29;
}

.crop-modal-body {
  padding: 16px 20px;
  overflow: auto;
  flex: 1;
  min-height: 0;
}

.crop-modal-hint {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #6c757d;
}

.crop-container {
  max-height: 60vh;
  min-height: 280px;
}

.crop-container .crop-image {
  max-width: 100%;
  display: block;
}

.crop-modal-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 20px;
  border-top: 1px solid #e9ecef;
}

.crop-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.crop-btn-cancel {
  background: #f5f5f5;
  color: #333;
}

.crop-btn-cancel:hover {
  background: #e9ecef;
}

.crop-btn-apply {
  background: #07A0C3;
  color: #fff;
}

.crop-btn-apply:hover {
  background: #0590b0;
}

.crop-mode-toggle {
  display: inline-flex;
  border-radius: 999px;
  background: #f1f3f5;
  padding: 3px;
  margin-bottom: 10px;
}

.crop-mode-btn {
  border: none;
  background: transparent;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 13px;
  cursor: pointer;
  color: #495057;
}

.crop-mode-btn.is-active {
  background: #07A0C3;
  color: #fff;
}

/* Ad slot: same width and center as form/video below */
.accommodation-ad-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 1px;
}

/* Accommodation video tutorial section */
.video-tutorials-section {
  margin-top: 24px;
  margin-bottom: 24px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  direction: rtl;
  text-align: center;
}

[dir="ltr"] .video-tutorials-section {
  direction: ltr;
  text-align: center;
}

.video-tutorials-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #0D2F29;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.video-tutorials-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.video-tutorial-item {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.video-tutorial-card {
  cursor: pointer;
  padding: 16px;
  transition: background-color 0.2s ease;
  min-height: 50px;
  display: flex;
  align-items: center;
}

.video-tutorial-card:hover {
  background-color: #f0f0f0;
}

.video-tutorial-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.video-tutorials-section .video-tutorial-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #0D2F29;
  margin: 0;
  flex: 1;
  text-align: center;
}

.video-tutorial-arrow {
  font-size: 12px;
  color: #07A0C3;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.video-tutorial-arrow.is-open {
  transform: rotate(90deg);
}

.video-container-wrapper {
  padding: 0 16px 16px 16px;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.slide-down-enter,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-down-enter-to,
.slide-down-leave {
  max-height: 1000px;
  opacity: 1;
}

.tutorial-video-container {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background-color: #000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.tutorial-video {
  width: 100%;
  height: auto;
  display: block;
  max-height: 60vh;
}

.video-loading,
.video-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 2rem;
  color: #666;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.video-loading p,
.video-error p {
  margin-top: 1rem;
  font-size: 14px;
  text-align: center;
}

.retry-button {
  margin-top: 1rem;
  padding: 8px 20px;
  background-color: #07A0C3;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.retry-button:hover {
  background-color: #0590b0;
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.spinner-border.text-primary {
  color: #07A0C3;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.voucher-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  font-size: 1.4rem;
}
.voucher-row-icon {
  color: #07A0C3;
  font-size: 20px;
  flex-shrink: 0;
}
.voucher-row-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.voucher-row-remove {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 16px;
  flex-shrink: 0;
  padding: 2px 6px;
  border-radius: 4px;
}
.voucher-row-remove:hover {
  background: #f0f0f0;
  color: #333;
}

.voucher-save-pending-msg {
  font-size: 1.3rem;
  font-weight: 600;
  color: #0a6ea8;
  background: #e8f4fd;
  border: 1px solid #90caf9;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-top: 0.75rem;
}

.voucher-max-reached-msg {
  font-size: 1.4rem;
  font-weight: 600;
  color: #b05c00;
  background: #fff3e0;
  border: 1px solid #ffb74d;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-top: 0.5rem;
  text-align: right;
}

[dir="ltr"] .voucher-max-reached-msg {
  text-align: left;
}
</style>
